import { render, staticRenderFns } from "./ContentAddInPPT.vue?vue&type=template&id=090a636e&scoped=true&"
import script from "./ContentAddInPPT.vue?vue&type=script&lang=js&"
export * from "./ContentAddInPPT.vue?vue&type=script&lang=js&"
import style0 from "./ContentAddInPPT.vue?vue&type=style&index=0&id=090a636e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a636e",
  null
  
)

export default component.exports